import Axios from "axios";
import {
    SET_PUR_PO_ORDER_REPORT,
    UNSET_PUR_PO_ORDER_REPORT,
} from "@/store/mutation-types";
import { getPurPOOrderReport } from "@/store/api";

const state = {
    getPurPOOrderReport: [],
};

const getters = {
    getPurPOOrderReport(state) {
        return state.getPurPOOrderReport;
    },
};

const mutations = {
    [SET_PUR_PO_ORDER_REPORT](state, data) {
        state.getPurPOOrderReport = data;
    },
    [UNSET_PUR_PO_ORDER_REPORT](state) {
        state.getPurPOOrderReport = [];
    },
};

const actions = {
    getPurPOOrderReport({ commit }, params) {
        commit("SET_LOADING", { color: "primary" });
        return new Promise((resolve, reject) => {
            Axios.get(getPurPOOrderReport, { params })
                .then((response) => {
                    commit(SET_PUR_PO_ORDER_REPORT, response.data.data);
                    resolve(response);
                })
                .catch((error) => {
                    commit(UNSET_PUR_PO_ORDER_REPORT);
                    reject(error);
                })
                .finally(() => {
                    commit("UNSET_LOADING");
                });
        });
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};


